import React from "react";
import { useApp } from "../context/AppContext";
import {
  LayoutDashboard, ArrowLeftRight, Lightbulb,
  TrendingUp, Shield, Eye, ChevronDown, Zap
} from "lucide-react";

const navItems = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "transactions", label: "Transactions", icon: ArrowLeftRight },
  { id: "insights", label: "Insights", icon: Lightbulb },
];

export default function Sidebar({ mobile, onClose }) {
  const { state, dispatch } = useApp();

  const setTab = (tab) => {
    dispatch({ type: "SET_TAB", payload: tab });
    if (onClose) onClose();
  };

  return (
    <aside className={`
      flex flex-col h-full bg-bg-secondary border-r border-border
      ${mobile ? "w-72" : "w-64 hidden lg:flex"}
    `}>

      <div className="p-6 border-b border-border">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-accent-cyan/10 border border-accent-cyan/30 flex items-center justify-center animate-glow">
            <Zap size={18} className="text-accent-cyan" />
          </div>
          <div>
            <h1 className="font-display font-bold text-white text-lg leading-none">DailyTrack</h1>
            <p className="text-xs text-white/30 font-body mt-0.5">Finance Dashboard</p>
          </div>
        </div>
      </div>

      <div className="p-4 border-b border-border">
        <p className="text-xs text-white/30 font-body uppercase tracking-widest mb-2">Role</p>
        <div className="grid grid-cols-2 gap-1 bg-bg-card rounded-lg p-1">
          {["viewer", "admin"].map((r) => (
            <button
              key={r}
              onClick={() => dispatch({ type: "SET_ROLE", payload: r })}
              className={`
                flex items-center justify-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-body font-medium
                transition-all duration-300 capitalize
                ${state.role === r
                  ? "bg-accent-cyan text-bg-primary shadow-lg shadow-accent-cyan/20"
                  : "text-white/40 hover:text-white/70"
                }
              `}
            >
              {r === "viewer" ? <Eye size={12} /> : <Shield size={12} />}
              {r}
            </button>
          ))}
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1">
        <p className="text-xs text-white/30 font-body uppercase tracking-widest mb-3">Navigation</p>
        {navItems.map(({ id, label, icon: Icon }, i) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            style={{ animationDelay: `${i * 80}ms` }}
            className={`
              w-full flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-body font-medium
              transition-all duration-300 group animate-slide-up
              ${state.activeTab === id
                ? "bg-accent-cyan/10 text-accent-cyan border border-accent-cyan/20"
                : "text-white/40 hover:text-white hover:bg-bg-hover"
              }
            `}
          >
            <Icon size={17} className="flex-shrink-0" />
            {label}
            {state.activeTab === id && (
              <div className="ml-auto w-1.5 h-1.5 rounded-full bg-accent-cyan animate-pulse" />
            )}
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-border">
        <div className="bg-bg-card rounded-xl p-3 border border-border">
          <p className="text-xs text-white/30 font-body mb-1">Active Role</p>
          <div className="flex items-center gap-2">
            {state.role === "admin" ? <Shield size={14} className="text-accent-gold" /> : <Eye size={14} className="text-accent-cyan" />}
            <span className="text-sm font-body font-medium text-white capitalize">{state.role}</span>
            <span className={`ml-auto text-xs px-2 py-0.5 rounded-full font-mono ${state.role === "admin" ? "bg-accent-gold/10 text-accent-gold" : "bg-accent-cyan/10 text-accent-cyan"
              }`}>
              {state.role === "admin" ? "Full Access" : "Read Only"}
            </span>
          </div>
        </div>
      </div>
    </aside>
  );
}
